import api from "../utils/api";

export const sendEmail = async (msg) =>
  await api.post(process.env.VUE_APP_USER_CLOUD_API_BASE + "sendEmail", msg);
